import m from "mithril";

import css from "./index.css";

export default {
    view : () => m("img", { class : css.formLogo, src : "https://account.staticwars.com/img/logo-black.svg", alt : "ArenaNet" })
};
